import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, inject } from 'vue';
import { FormItemInjection, formItemInjectionKey } from '@/core/components/forms/Form/form.shared';
import { StTextarea } from './textarea.style';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkTextArea',
  setup(__props) {

const injection = inject(formItemInjectionKey) as FormItemInjection;
const error = computed(() => !!(injection?.error.value));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(StTextarea), _mergeProps({ error: _unref(error) }, _ctx.$attrs), null, 16, ["error"]))
}
}

})